import { CHECKOUT, DONATIONS, FPTI } from './constants';
// as of 0/3/18/21 this helper just enables amplitude for existing CTA clicks
// (Details Header all apps AND Checkout/Donations Details CTA)
// More logic will be added here to enable additional clicks on details

const {
  GENERIC_GET_STARTED_LINK,
  CHECKOUT_BUTTON_GENERATOR_LINK,
  CHECKOUT_STANDARD_INTEGRATION_LINK,
  CHECKOUT_ADVANCED_INTEGRATION_LINK,
  CHECKOUT_DETAILS_CTA_CONNECT_LINK,
  DONATIONS_DETAILS_CTA_APPLY_NOW_LINK
} = FPTI;

const checkoutLinks = [
  CHECKOUT_BUTTON_GENERATOR_LINK,
  CHECKOUT_STANDARD_INTEGRATION_LINK,
  CHECKOUT_ADVANCED_INTEGRATION_LINK,
  CHECKOUT_DETAILS_CTA_CONNECT_LINK
];

// This logic selects the click events that are designated 'get started'/ CTA events by amplitude
export const isDetailsClickGetStarted = (fptiLinkName = '', appKey = '') => {
  const isSupportedCTAClick = Boolean(
    // DetailsHeader CTA (any/all apps except checkout, which is special case)
    (fptiLinkName === GENERIC_GET_STARTED_LINK && appKey !== CHECKOUT) ||
      // Checkout special case - PhotoRow CTA OR Details_CTA
      (appKey === CHECKOUT && checkoutLinks.includes(fptiLinkName)) ||
      // Donations DetailsCTA
      (appKey === DONATIONS &&
        fptiLinkName === DONATIONS_DETAILS_CTA_APPLY_NOW_LINK)
  );

  return isSupportedCTAClick;
};
